import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "col-12 m-0 p-0" };
const _hoisted_2 = { class: "col-12 m-0 p-0" };
const _hoisted_3 = { class: "col-12 m-0 p-0" };
const _hoisted_4 = { class: "col-12 m-0 p-0" };
const _hoisted_5 = { class: "form-group" };
const _hoisted_6 = { class: "col-12 m-0 p-0 mb-3" };
const _hoisted_7 = { class: "col-12 m-0 p-0" };
const _hoisted_8 = {
    key: 0,
    class: "m-0 p-0"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_base_input = _resolveComponent("base-input");
    const _component_base_email_input = _resolveComponent("base-email-input");
    return (_openBlock(), _createElementBlock("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event) => (_ctx.sendRepairRequestMail()), ["prevent"])),
        class: "mb-sm-4",
        name: "repair_request_contact_form",
        id: "repair_request_contact_form"
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
                _createVNode(_component_base_input, {
                    modelValue: _ctx.formValues.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formValues.name) = $event)),
                    type: "text",
                    "data-validation-type": "text",
                    name: "name",
                    placeholder: "Name*",
                    id: "contactName",
                    rules: _ctx.stringRequiredRule
                }, null, 8, ["modelValue", "rules"]),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "invalid-feedback-empty hidden text-left font7" }, "Bitte geben Sie Ihren Namen ein.", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "invalid-feedback text-left font7" }, "Bitte geben Sie Ihren Namen ein.", -1))
            ])
        ]),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
                _createVNode(_component_base_input, {
                    modelValue: _ctx.formValues.phoneNumber,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.formValues.phoneNumber) = $event)),
                    type: "tel",
                    name: "phoneNumber",
                    placeholder: "Telefonnummer",
                    id: "contactPhone"
                }, null, 8, ["modelValue"]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "invalid-feedback hidden text-left font7" }, " Deine Telefonnummer scheint nicht korrekt zu sein. ", -1))
            ])
        ]),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
                _createVNode(_component_base_email_input, {
                    required: true,
                    modelValue: _ctx.formValues.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formValues.email) = $event)),
                    type: "email",
                    "data-validation-type": "email",
                    name: "email",
                    placeholder: "E-Mail-Adresse*",
                    id: "contactEmail"
                }, null, 8, ["modelValue"]),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "invalid-feedback-empty hidden text-left font7" }, " Bitte geben Sie Ihre E-Mail Adresse ein. ", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "invalid-feedback text-left font7" }, "Diese E-Mail Adresse scheint nicht korrekt zu sein.", -1))
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _cache[13] || (_cache[13] = _createElementVNode("label", {
                    for: "device",
                    class: "hidden"
                }, "Gerätemodel", -1)),
                _createVNode(_component_base_input, {
                    rules: _ctx.stringRequiredRule,
                    modelValue: _ctx.formValues.device,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.formValues.device) = $event)),
                    type: "text",
                    "data-validation-type": "text",
                    name: "device",
                    placeholder: "Gerätemodell*",
                    id: "device"
                }, null, 8, ["rules", "modelValue"]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "invalid-feedback-empty hidden text-left font7" }, " Bitte gib die Bezeichnung von deinem Gerät ein. ", -1))
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _cache[16] || (_cache[16] = _createElementVNode("label", {
                for: "store",
                class: "hidden"
            }, "Store wählen* (Nord, Mitte oder Weserpark)", -1)),
            _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formValues.shop) = $event)),
                class: "custom-select",
                "data-chosen": "",
                name: "store",
                style: { "cursor": "pointer", "height": "48px" }
            }, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("option", { value: "" }, "Store wählen*", -1),
                    _createElementVNode("option", { value: "bremen_mitte" }, "Store Mitte", -1),
                    _createElementVNode("option", { value: "bremen_weserpark" }, "Store Ost (Weserpark)", -1),
                    _createElementVNode("option", { value: "bremen_nord" }, "Store Nord", -1)
                ]))], 512), [
                [_vModelSelect, _ctx.formValues.shop]
            ])
        ]),
        _createElementVNode("div", _hoisted_7, [
            _cache[19] || (_cache[19] = _createElementVNode("label", {
                for: "damageType",
                class: "hidden"
            }, "Schaden wählen", -1)),
            _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.formValues.damageType) = $event)),
                class: "custom-select",
                "data-chosen": "",
                name: "damageType",
                style: { "cursor": "pointer", "height": "48px" }
            }, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("option", { value: "" }, "Schadensart*", -1),
                    _createElementVNode("option", { value: "Akku defekt" }, "Akku defekt", -1),
                    _createElementVNode("option", { value: "Display defekt" }, "Display defekt", -1),
                    _createElementVNode("option", { value: "Sonstiger Schaden" }, "Sonstiger Schaden", -1)
                ]))], 512), [
                [_vModelSelect, _ctx.formValues.damageType]
            ]),
            (_ctx.formValues.damageType === 'Sonstiger Schaden')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", {
                        for: "damageTypeInfoText",
                        class: "f5-responsive strong pt-4"
                    }, " Bitte beschreibe den Schaden genauer und gib uns weitere Informationen zu deinem Gerät (max. 500 Zeichen). ", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.formValues.damageTypeInfoText) = $event)),
                        maxlength: "500",
                        autoscroll: "",
                        class: "form-control",
                        name: "damageTypeInfoText",
                        style: { "cursor": "pointer", "height": "200px", "overflow": "hidden", "resize": "none" }
                    }, null, 512), [
                        [_vModelText, _ctx.formValues.damageTypeInfoText]
                    ])
                ]))
                : _createCommentVNode("", true)
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-left font8-responsive mt-3 mb-2" }, [
            _createTextVNode(" Hier findest Du unsere "),
            _createElementVNode("a", {
                href: "/datenschutz",
                target: "_blank",
                title: "Datenschutzbestimmungen",
                class: "link-in-text"
            }, " Datenschutzerklärung ")
        ], -1)),
        _cache[21] || (_cache[21] = _createElementVNode("p", { class: "font7-responsive mb-4" }, "*Pflichtfeld", -1)),
        _cache[22] || (_cache[22] = _createElementVNode("button", {
            class: "buttonBase buttonGreen font6 w-sm-100 font6 mb-4 px-sm-5",
            type: "submit",
            id: "RepairRequest"
        }, " Anfrage absenden ", -1))
    ], 32));
}
